// Device slice screen measurements aren't updating on resize
// Don't want to throttle store with dispatches on resize so using these utils

export const getViewportWidth = () => {
    return window.innerWidth && document.documentElement.clientWidth
        ? Math.min(window.innerWidth, document.documentElement.clientWidth)
        : window.innerWidth ||
              document.documentElement.clientWidth ||
              document.getElementsByTagName('body')[0].clientWidth
}

export const getViewportHeight = () => {
    return window.innerHeight && document.documentElement.clientHeight
        ? Math.min(window.innerHeight, document.documentElement.clientHeight)
        : window.innerHeight ||
              document.documentElement.clientHeight ||
              document.getElementsByTagName('body')[0].clientHeight
}
